const actions = {
    /* PROVIDERS */
    FLOW_READ_ALL_PROVIDERS_REQUEST: 'FLOW_READ_ALL_PROVIDERS_REQUEST',
    FLOW_READ_ALL_PROVIDERS_SUCCESS: 'FLOW_READ_ALL_PROVIDERS_SUCCESS',
    FLOW_READ_ALL_PROVIDERS_ERROR: 'FLOW_READ_ALL_PROVIDERS_ERROR',

    FLOW_CONNECT_OAUTH2_REQUEST: 'FLOW_CONNECT_OAUTH2_REQUEST',
    FLOW_CONNECT_OAUTH2_SUCCESS: 'FLOW_CONNECT_OAUTH2_SUCCESS',
    FLOW_CONNECT_OAUTH2_ERROR: 'FLOW_CONNECT_OAUTH2_ERROR',

    // FLOW_CONNECT_HTTP_REQUEST: 'FLOW_CONNECT_HTTP_REQUEST',
    // FLOW_CONNECT_HTTP_SUCCESS: 'FLOW_CONNECT_HTTP_SUCCESS',
    // FLOW_CONNECT_HTTP_ERROR: 'FLOW_CONNECT_HTTP_ERROR',

    /* STREAMS */
    FLOW_READ_ALL_STREAMS_REQUEST: 'FLOW_READ_ALL_STREAMS_REQUEST',
    FLOW_READ_ALL_STREAMS_SUCCESS: 'FLOW_READ_ALL_STREAMS_SUCCESS',
    FLOW_READ_ALL_STREAMS_ERROR: 'FLOW_READ_ALL_STREAMS_ERROR',

    FLOW_READ_STREAM_REQUEST: 'FLOW_READ_STREAM_REQUEST',
    FLOW_READ_STREAM_SUCCESS: 'FLOW_READ_STREAM_SUCCESS',
    FLOW_READ_STREAM_ERROR: 'FLOW_READ_STREAM_ERROR',

    FLOW_READ_STREAM_MAPPING_REQUEST: 'FLOW_READ_STREAM_MAPPING_REQUEST',
    FLOW_READ_STREAM_MAPPING_SUCCESS: 'FLOW_READ_STREAM_MAPPING_SUCCESS',
    FLOW_READ_STREAM_MAPPING_ERROR: 'FLOW_READ_STREAM_MAPPING_ERROR',

    FLOW_CREATE_HTTP_STREAM_REQUEST: 'FLOW_CREATE_HTTP_STREAM_REQUEST',
    FLOW_CREATE_HTTP_STREAM_SUCCESS: 'FLOW_CREATE_HTTP_STREAM_SUCCESS',
    FLOW_CREATE_HTTP_STREAM_ERROR: 'FLOW_CREATE_HTTP_STREAM_ERROR',

    FLOW_UPDATE_STREAM_REQUEST: 'FLOW_UPDATE_STREAM_REQUEST',
    FLOW_UPDATE_STREAM_SUCCESS: 'FLOW_UPDATE_STREAM_SUCCESS',
    FLOW_UPDATE_STREAM_ERROR: 'FLOW_UPDATE_STREAM_ERROR',

    FLOW_UPDATE_STREAM_MAPPINGS_REQUEST: 'FLOW_UPDATE_STREAM_MAPPINGS_REQUEST',
    FLOW_UPDATE_STREAM_MAPPINGS_SUCCESS: 'FLOW_UPDATE_STREAM_MAPPINGS_SUCCESS',
    FLOW_UPDATE_STREAM_MAPPINGS_ERROR: 'FLOW_UPDATE_STREAM_MAPPINGS_ERROR',

    FLOW_SYNCHRONIZE_STREAM_REQUEST: 'FLOW_SYNCHRONIZE_STREAM_REQUEST',
    FLOW_SYNCHRONIZE_STREAM_SUCCESS: 'FLOW_SYNCHRONIZE_STREAM_SUCCESS',
    FLOW_SYNCHRONIZE_STREAM_ERROR: 'FLOW_SYNCHRONIZE_STREAM_ERROR',

    FLOW_DEACTIVATE_STREAM_REQUEST: 'FLOW_DEACTIVATE_STREAM_REQUEST',
    FLOW_DEACTIVATE_STREAM_SUCCESS: 'FLOW_DEACTIVATE_STREAM_SUCCESS',
    FLOW_DEACTIVATE_STREAM_ERROR: 'FLOW_DEACTIVATE_STREAM_ERROR',

    FLOW_ACTIVATE_STREAM_REQUEST: 'FLOW_ACTIVATE_STREAM_REQUEST',
    FLOW_ACTIVATE_STREAM_SUCCESS: 'FLOW_ACTIVATE_STREAM_SUCCESS',
    FLOW_ACTIVATE_STREAM_ERROR: 'FLOW_ACTIVATE_STREAM_ERROR',

    FLOW_DELETE_STREAM_REQUEST: 'FLOW_DELETE_STREAM_REQUEST',
    FLOW_DELETE_STREAM_SUCCESS: 'FLOW_DELETE_STREAM_SUCCESS',
    FLOW_DELETE_STREAM_ERROR: 'FLOW_DELETE_STREAM_ERROR',

    /* DIGESTS */
    FLOW_READ_ALL_DIGESTS_REQUEST: 'FLOW_READ_ALL_DIGESTS_REQUEST',
    FLOW_READ_ALL_DIGESTS_SUCCESS: 'FLOW_READ_ALL_DIGESTS_SUCCESS',
    FLOW_READ_ALL_DIGESTS_ERROR: 'FLOW_READ_ALL_DIGESTS_ERROR',

    FLOW_BULK_DELETE_DIGESTS_REQUEST: 'FLOW_BULK_DELETE_DIGESTS_REQUEST',
    FLOW_BULK_DELETE_DIGESTS_SUCCESS: 'FLOW_BULK_DELETE_DIGESTS_SUCCESS',
    FLOW_BULK_DELETE_DIGESTS_ERROR: 'FLOW_BULK_DELETE_DIGESTS_ERROR',

    FLOW_BULK_POSTING_REQUEST: 'FLOW_BULK_POSTING_REQUEST',
    FLOW_BULK_POSTING_SUCCESS: 'FLOW_BULK_POSTING_SUCCESS',
    FLOW_BULK_POSTING_ERROR: 'FLOW_BULK_POSTING_ERROR',

    FLOW_POST_DIGEST_TO_INVOICE_REQUEST: 'FLOW_POST_DIGEST_TO_INVOICE_REQUEST',
    FLOW_POST_DIGEST_TO_INVOICE_SUCCESS: 'FLOW_POST_DIGEST_TO_INVOICE_SUCCESS',
    FLOW_POST_DIGEST_TO_INVOICE_ERROR: 'FLOW_POST_DIGEST_TO_INVOICE_ERROR',

    FLOW_DELETE_DIGEST_REQUEST: 'FLOW_DELETE_DIGEST_REQUEST',
    FLOW_DELETE_DIGEST_SUCCESS: 'FLOW_DELETE_DIGEST_SUCCESS',
    FLOW_DELETE_DIGEST_ERROR: 'FLOW_DELETE_DIGEST_ERROR',

    FLOW_READ_DIGEST_SUMMARY_REQUEST: 'FLOW_READ_DIGEST_SUMMARY_REQUEST',
    FLOW_READ_DIGEST_SUMMARY_SUCCESS: 'FLOW_READ_DIGEST_SUMMARY_SUCCESS',
    FLOW_READ_DIGEST_SUMMARY_ERROR: 'FLOW_READ_DIGEST_SUMMARY_ERROR',

    FLOW_READ_DIGEST_ITEMS_REQUEST: 'FLOW_READ_DIGEST_ITEMS_REQUEST',
    FLOW_READ_DIGEST_ITEMS_SUCCESS: 'FLOW_READ_DIGEST_ITEMS_SUCCESS',
    FLOW_READ_DIGEST_ITEMS_ERROR: 'FLOW_READ_DIGEST_ITEMS_ERROR',

    FLOW_READ_DIGEST_ORDERS_REQUEST: 'FLOW_READ_DIGEST_ORDERS_REQUEST',
    FLOW_READ_DIGEST_ORDERS_SUCCESS: 'FLOW_READ_DIGEST_ORDERS_SUCCESS',
    FLOW_READ_DIGEST_ORDERS_ERROR: 'FLOW_READ_DIGEST_ORDERS_ERROR',

    FLOW_READ_DIGEST_ORDER_ITEMS_REQUEST: 'FLOW_READ_DIGEST_ORDER_ITEMS_REQUEST',
    FLOW_READ_DIGEST_ORDER_ITEMS_SUCCESS: 'FLOW_READ_DIGEST_ORDER_ITEMS_SUCCESS',
    FLOW_READ_DIGEST_ORDER_ITEMS_ERROR: 'FLOW_READ_DIGEST_ORDER_ITEMS_ERROR',

    FLOW_RESET_DIGEST: 'FLOW_RESET_DIGEST',

    /* PROVIDERS */
    readAllProviders: () => ({
        type: actions.FLOW_READ_ALL_PROVIDERS_REQUEST,
    }),

    connectOauth2: (providerId, flowStreamId) => ({
        type: actions.FLOW_CONNECT_OAUTH2_REQUEST,
        providerId,
        flowStreamId,
    }),

    // connectHttp: request => ({
    //     type: actions.FLOW_CONNECT_HTTP_REQUEST,
    //     request, //
    //     // {
    //     //     flow_provider_id
    //     //     ext_name
    //     //     auto_sync
    //     //     auto_create_invoice
    //     //     contact_id
    //     //     grouping
    //     //     username (→ access_token)
    //     //     password (→ refresh_token)
    //     //     sync_starts_at (Date)
    //     //     fee_mappings, array of objects // {flow_fee_type_id,  account_id}
    //     // }
    // }),

    /* STREAMS */
    // Read All Streams
    readAllStreams: request => ({
        type: actions.FLOW_READ_ALL_STREAMS_REQUEST,
        request, // {page, page_size}
    }),

    // Read Single Stream
    readStream: streamId => ({
        type: actions.FLOW_READ_STREAM_REQUEST,
        streamId,
    }),

    readStreamMappings: streamId => ({
        type: actions.FLOW_READ_STREAM_MAPPING_REQUEST,
        streamId,
    }),

    createHttpStream: request => ({
        type: actions.FLOW_CREATE_HTTP_STREAM_REQUEST,
        request, //
        // {
        //     flow_provider_id
        //     ext_name
        //     auto_sync
        //     auto_create_invoice
        //     contact_id
        //     grouping
        //     username (→ access_token)
        //     password (→ refresh_token)
        //     sync_starts_at (Date)
        //     fee_mappings, array of objects // {flow_fee_type_id,  account_id}
        // }

    }),

    // Update Stream
    updateStream: (streamId, request) => ({
        type: actions.FLOW_UPDATE_STREAM_REQUEST,
        streamId,
        request,
        // {
        //     ext_name - For HTTP_BASIC only.
        //     auto_sync
        //     auto_create_invoice
        //     contact_id
        //     grouping
        //     username (→ access_token) For HTTP_BASIC only.
        //     password (→ refresh_token) For HTTP_BASIC only.
        //     sync_starts_at (Date)
        //     fee_mappings, array of objects // {flow_fee_type_id, account_id}
        // }
    }),

    // Update Stream Mappings
    updateStreamMappings: (streamId, request) => ({
        type: actions.FLOW_UPDATE_STREAM_MAPPINGS_REQUEST,
        streamId,
        request, // {fee_mappings, locations, tax_codes, payment_methods}
    }),

    // Synchronize Stream
    synchronizeStream: streamId => ({
        type: actions.FLOW_SYNCHRONIZE_STREAM_REQUEST,
        streamId,
    }),

    // Deactivate Stream
    deactivateStream: streamId => ({
        type: actions.FLOW_DEACTIVATE_STREAM_REQUEST,
        streamId,
    }),

    // Activate Stream
    activateStream: streamId => ({
        type: actions.FLOW_ACTIVATE_STREAM_REQUEST,
        streamId,
    }),

    // Delete Stream (HARD DELETE)
    deleteStream: streamId => ({
        type: actions.FLOW_DELETE_STREAM_REQUEST,
        streamId,
    }),

    /* DIGESTS */
    // Read all digests
    readAllDigests: (streamId, request) => ({
        type: actions.FLOW_READ_ALL_DIGESTS_REQUEST,
        request,
        streamId,
    }),

    bulkDeleteDigests: (streamId, request) => ({
        type: actions.FLOW_BULK_DELETE_DIGESTS_REQUEST,
        request, // {ids: array of ids}
        streamId,
    }),

    bulkPostDigests: (streamId, request) => ({
        type: actions.FLOW_BULK_POSTING_REQUEST,
        request, // {ids: array of ids}
        streamId,
    }),

    postDigestToInvoice: (streamId, digestId, {refetchList = false}) => ({
        type: actions.FLOW_POST_DIGEST_TO_INVOICE_REQUEST,
        streamId,
        digestId,
        refetchList,
    }),

    deleteDigest: (streamId, digestId, {refetchList = false}) => ({
        type: actions.FLOW_DELETE_DIGEST_REQUEST,
        streamId,
        digestId,
        refetchList,
    }),

    readDigestSummary: (streamId, digestId) => ({
        type: actions.FLOW_READ_DIGEST_SUMMARY_REQUEST,
        streamId,
        digestId,
    }),

    readDigestItems: (streamId, digestId, request) => ({
        type: actions.FLOW_READ_DIGEST_ITEMS_REQUEST,
        streamId,
        digestId,
        request,
    }),

    readDigestOrders: (streamId, digestId, request) => ({
        type: actions.FLOW_READ_DIGEST_ORDERS_REQUEST,
        streamId,
        digestId,
        request,
    }),

    readDigestOrderItems: (streamId, digestId, orderId) => ({
        type: actions.FLOW_READ_DIGEST_ORDER_ITEMS_REQUEST,
        streamId,
        digestId,
        orderId,
    }),

    resetDigest: () => ({
        type: actions.FLOW_RESET_DIGEST,
    }),

};

export default actions;
